import Vue from "vue";
import Router from "vue-router";

const home = (resolve) => require(["../views/home.vue"], resolve);
const advantage = (resolve) =>
  require(["../views/about/advantage.vue"], resolve);
const contentUS = (resolve) =>
  require(["../views/about/contentUS.vue"], resolve);
const partner = (resolve) => require(["../views/partner/partner.vue"], resolve);
const products = (resolve) =>
  require(["../views/products/products.vue"], resolve);
const techCenter = (resolve) =>
  require(["../views/techCenter/techCenter.vue"], resolve);
const MIndex = (resolve) => require(["../views/MoblieHome.vue"], resolve);
const MProducts = (resolve) =>
  require(["../views/MoblieProducts.vue"], resolve);
const MTech = (resolve) => require(["../views/MoblieTech.vue"], resolve);
const MContentUS = (resolve) =>
  require(["../views/MoblieContentUS.vue"], resolve);
const MAdvantage = (resolve) =>
  require(["../views/MoblieAdvantage.vue"], resolve);
const MPartner = (resolve) => require(["../views/MobliePartner.vue"], resolve);
const detail = (resolve) => require(["../views/detail/detail.vue"], resolve);
const MDetail = (resolve) => require(["../views/MobileDetail.vue"], resolve);
const newsList = (resolve) => require(["../views/post/list.vue"], resolve);
const news = (resolve) => require(["../views/post/news.vue"], resolve);
const tips = (resolve) => require(["../views/post/tips.vue"], resolve);

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: home,
      meta: {
        title: "【小原齿轮】专营KHK齿轮│上海米仑机械设备有限公司【官网】",
      },
    },
    {
      path: "/products/detail/:guid",
      component: detail,
    },
    // {
    //   path: "/news/",
    //   component: news,
    // },
    {
      path: "/post/list",
      component: newsList,
    },
    {
      path: "/post/news/:id",
      component: news,
    },
    {
      path: "/post/tips/:id",
      component: tips,
    },
    {
      path: "/m_detail/:guid",
      component: MDetail,
    },
    {
      path: "/m_index",
      component: MIndex,
      meta: {
        title: "【小原齿轮】专营KHK齿轮│上海米仑机械设备有限公司【官网】",
      },
    },
    {
      path: "/m_products/:id",
      component: MProducts,
      meta: {
        title: "KHK齿轮齿条_蜗轮蜗杆_齿轮箱_棘轮棘爪┃专营产品【米仑机械】",
      },
    },
    {
      path: "/m_tech/:id",
      component: MTech,
      meta: {
        title:
          "KHK小原齿轮┃齿轮问答_图纸下载_计算公式_齿轮应用┃技术中心【米仑机械】",
      },
    },
    {
      path: "/m_contentUS",
      component: MContentUS,
      meta: {
        title: "KHK小原齿轮样册索取_联系我们┃关于我们【米仑机械】",
      },
    },
    {
      path: "/m_advantage",
      component: MAdvantage,
      meta: {
        title: "合作优势┃关于我们【米仑机械】",
      },
    },
    {
      path: "/m_partner",
      component: MPartner,
      meta: {
        title: "日本KHK小原齿轮┃合作伙伴┃上海米仑机械设备有限公司",
      },
    },
    {
      path: "/advantage",
      component: advantage,
      meta: {
        title: "合作优势┃关于我们【米仑机械】",
      },
    },
    {
      path: "/contentUS",
      component: contentUS,
      meta: {
        title: "KHK小原齿轮样册索取_联系我们┃关于我们【米仑机械】",
      },
    },
    {
      path: "/partner",
      component: partner,
      meta: {
        title: "日本KHK小原齿轮┃合作伙伴┃上海米仑机械设备有限公司",
      },
    },
    {
      path: "/products/:id",
      component: products,
      meta: {
        title: "KHK齿轮齿条_蜗轮蜗杆_齿轮箱_棘轮棘爪┃专营产品【米仑机械】",
      },
    },
    {
      path: "/techCenter/:id",
      component: techCenter,
      meta: {
        title:
          "KHK小原齿轮┃齿轮问答_图纸下载_计算公式_齿轮应用┃技术中心【米仑机械】",
      },
    },
    {
      path: "*",
      component: home,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    if (to.path === "/") {
      switch (to.hash) {
        case "/":
          document.title = to.meta.title;
          break;
        case "#home":
          document.title =
            "【小原齿轮】专营KHK齿轮│上海米仑机械设备有限公司【官网】";
          break;
        case "#introduction":
          document.title = "公司概要_沿革┃企业介绍【米仑机械】";
          break;
        case "#origin":
          document.title = "公司名称由来┃企业介绍【米仑机械】";
          break;
        case "#importExport":
          document.title = "资质证明┃上海米仑机械设备有限公司";
          break;
        case "#partner":
          document.title = "日本KHK小原齿轮┃合作伙伴┃上海米仑机械设备有限公司";
          break;
        case "#aboutUs":
          document.title = "合作优势┃关于我们【米仑机械】";
          break;
        case "#products":
          document.title =
            "KHK齿轮齿条_蜗轮蜗杆_齿轮箱_棘轮棘爪┃专营产品【米仑机械】";
          break;
        case "#techCenter":
          document.title =
            "KHK小原齿轮┃齿轮问答_图纸下载_计算公式_齿轮应用┃技术中心【米仑机械】";
          break;
        default:
          break;
      }
    } else {
      document.title = `${to.meta.title}`;
    }
  }
  next();
});

export default router;
